import React from "react";
import styled from "styled-components";

import Menu from "../../../../components/Menu";
import ContentDash from "../../../DashPaciente/ContentDash";

const UpgradeController: React.FC = () => {
	return (
		<ViewPort>
			<Menu setMenu="conta"></Menu>
			<ContentDash listagem={"upgrade"} />
		</ViewPort>
	);
};

export const ViewPort = styled.div`
	display: flex;
`;

export default UpgradeController;
